module.exports = __webpack_public_path__ + "static/media/induscreed.56952ac6.png";